import { render } from "./AlarmThresholdSetting.vue?vue&type=template&id=6ffd24de"
import script from "./AlarmThresholdSetting.vue?vue&type=script&lang=js"
export * from "./AlarmThresholdSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__